<div class="text-dropdown">
   <p><ng-content></ng-content></p>
   <ctp-dropdown-box class="dropdown-box-ref" [options]="options" (optionClick)="handleOptionClicked($event)"></ctp-dropdown-box>
</div>
